var lib_core = require("lib-core");

var AssetAdderModel = function () {
    var self = this;
    lib_core.Model.call(this);

     // We need a better way to solve popups, this is bad.
     // I expecially should not need a model just for this.
     //     Add it to the 'eventually' list, I would like the model and view for popups
            // to be handled in some parent extension (like I did for loading)
            //  So I can just have a dependancy on that extension,
            //  then set the popup config directly from any state machine / model.

    this.selectVersionModalShown = this.value("selectVersionModalShown", true);
};
lib_core.inherit(AssetAdderModel, lib_core.Model);
AssetAdderModel.$class = "AssetAdderModel";

module.exports = AssetAdderModel;
